import { Col, Row, Skeleton, Card, Button } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Company } from "@bindeleddet/core/types";
import AlternativeLogo from "components/AlternativeLogo/AlternativeLogo";
import { CompanyLogo } from "@bindeleddet/core/components";
import { StyledParagraph, StyledText, StyledTitle } from "./style";

interface Props {
  id: number;
  title: string;
  description: string;
  file: string;
  companyId: number;
  image?: string;
}

const SingleCaseBox: React.FC<Props> = ({ id, title, description, file, companyId, image }) => {
  const [company, setCompany] = useState<Company>();

  useEffect(() => {
    axios.get<Company>(`/companies/${companyId}/`).then(response => setCompany(response.data));
  }, [companyId]);

  return (
    <>
      <Card bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }} key={id}>
        <Row>
          <Col span={4}>
            {image ? (
              <AlternativeLogo size="100%" src={image.includes("http") ? image : axios.defaults.baseURL + image} />
            ) : company ? (
              <CompanyLogo size="100%" companyId={companyId} src={company.logo} />
            ) : (
              <Skeleton.Image />
            )}
          </Col>
          <Col
            xs={20}
            sm={16}
            style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
          >
            <Row>
              <StyledText>{company ? company.name : <Skeleton.Button active style={{ height: "1em" }} />}</StyledText>
            </Row>
            <Row>
              <StyledTitle level={4}>{title}</StyledTitle>
            </Row>
            <Row>
              <Col span={24}>
                <StyledParagraph ellipsis={{ rows: 2, expandable: true, symbol: "mer" }}>{description}</StyledParagraph>
              </Col>
            </Row>
          </Col>
          <Col
            xs={{ span: 5, offset: 18 }}
            sm={{ span: 4, offset: 0 }}
            style={{ alignItems: "center", justifyContent: "center", display: "flex" }}
          >
            <div style={{ textAlign: "center", lineHeight: "100%" }}>
              <Button
                type="primary"
                onClick={() => {
                  if (file) {
                    window.open(
                      file.includes("http") ? file : axios.defaults.baseURL + file,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                Last ned
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default SingleCaseBox;
